import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { OfflineGameBoard } from './components/offline/OfflineGameBoard';
import { OfflineNewGameForm } from './components/offline/NewGameForm';
import { JoinOnlineGameForm } from './components/online/JoinOnlineGameForm';
import { HostNewGameOnlineForm } from './components/online/HostNewGameOnlineForm';
import { OnlineGameBoard } from './components/online/OnlineGameBoard';
import { JoinOnlineByCodeForm } from './components/online/JoinOnlineByCodeForm';
import { RejoinOnlineGameForm } from './components/online/RejoinOnlineGameForm';

import './custom.css'

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
            <Route path='/new-game-offline' component={OfflineNewGameForm} />
            <Route path='/offline-game-board/:wordset/:turns' component={OfflineGameBoard} />
            <Route path='/new-game-online/:keepSession' component={HostNewGameOnlineForm} />
            <Route path='/join-game-online/:gameSessionId' component={JoinOnlineGameForm} />
            <Route path='/rejoin-game-online/:gameSessionId' component={RejoinOnlineGameForm} />
            <Route path='/online-game-board' component={OnlineGameBoard} />
            <Route path='/join-by-code' component={JoinOnlineByCodeForm} />
            <Route exact path='/' component={Home} />
      </Layout>
    );
  }
}
